export const product = [
    {
        id: 1,
        productName: "Kånken Sling Shoulder Bag",
        imageURL: "https://n.nordstrommedia.com/id/sr3/f6ea851c-18d7-4419-8c2d-e6fc73b097e9.jpeg?crop=pad&pad_color=FFF&format=jpeg&trim=color&trimcolor=FFF&w=780&h=838",
        price: 9625,
        description: "Moisture-repelling fabric shapes a slim and durable all-purpose backpa...",
        rating: 5,
        brand: "FJÄLLRÄVEN",
        color: "black",
        gender: "male",
    },
    {
        id: 2,
        productName: "Kånken Sling Shoulder Bag",
        imageURL: "https://n.nordstrommedia.com/id/sr3/caa68ad2-b74d-4d1d-92b6-acb5e85bef48.jpeg?crop=pad&pad_color=FFF&format=jpeg&trim=color&trimcolor=FFF&w=780&h=838",
        price: 6625,
        description: "Moisture-repelling fabric shapes a slim and durable all-purpose backpa...",
        rating: 4,
        brand: "FJÄLLRÄVEN",
        color: "black",
        gender: "male",
    },
    {
        id: 3,
        productName: "Kånken  Backpack",
        imageURL: "https://n.nordstrommedia.com/id/sr3/f7c18ba0-4b66-4fe9-a93d-61c3b6b84432.jpeg?crop=pad&pad_color=FFF&format=jpeg&trim=color&trimcolor=FFF&w=780&h=838",
        price: 9625,
        description: "Moisture-repelling fabric shapes a slim and durable all-purpose backpa...",
        rating: 3,
        brand: "FJÄLLRÄVEN",
        color: "black",
        gender: "male",
    },
    {
        id: 4,
        productName: "Kånken Sling Shoulder Bag",
        imageURL: "https://n.nordstrommedia.com/id/sr3/d66b24d3-d181-48be-b0e4-b10baf3eec8b.jpeg?crop=pad&pad_color=FFF&format=jpeg&trim=color&trimcolor=FFF&w=780&h=838",
        price: 5625,
        description: "Moisture-repelling fabric shapes a slim and durable all-purpose backpa...",
        rating: 5,
        brand: "FJÄLLRÄVEN",
        color: "black",
        gender: "male",
    }
]